<template>
  <v-system-bar v-if="isAdmin" color="red" height="10" class="text-uppercase position-fixed">
    <v-spacer></v-spacer>
    ADMIN MODE
    <v-spacer></v-spacer>
  </v-system-bar>
  <v-app-bar elevation="1">
    <template v-slot:prepend>
      <v-app-bar-nav-icon
        @click="storeLeftNav.isRailOpen = !storeLeftNav.isRailOpen"
        class="d-lg-none"
      ></v-app-bar-nav-icon>
      <v-btn @click="navigateTo('/')" :ripple="false">
        <v-img src="/images/logo/logo.png" width="160" class="mx-3"></v-img>
      </v-btn>
    </template>

    <v-container fluid class="d-none d-lg-flex justify-space-around">
      <!--
      <v-row v-if="systemBar.systemMsgText">
        <v-col>
          <template v-if="systemBar.systemMsgText">
            <v-icon icon="mdi-message" class="me-2"></v-icon>
            <span>{{ systemBar.systemMsgText }} styles in staging</span>
          </template>
        </v-col>
      </v-row>
      -->
      <div></div>
      <div></div>
      <v-btn
        v-for="(n, i) in storeLeftNav.nav"
        :key="`${i}-a`"
        v-show="!n.groups || n.groups.includes(userData.userGroup)"
        :to="!n.subItems ? n.to : null"
        :href="n.url"
        :target="n.url ? '_blank' : ''"
        :rel="n.url ? 'noopener' : ''"
        :class="width <= 1366 ? 'px-3' : ''"
      >
        {{ n.label }}

        <v-menu v-if="n.subItems && (!n.groups || n.groups.includes(userData.userGroup))" activator="parent">
          <v-list>
            <template v-for="(s, y) in n.subItems">
              <v-list-item
                v-if="!s.subItems"
                v-show="!s.groups || s.groups.includes(userData.userGroup)"
                :key="`${y}-c`"
                :to="s.to"
                :active="isNavItemExactActive(s.to)"
                :title="s.label"
                @click="s.action != null ? handleClick(s.action) : clearPage(s.to)"
                :style="s.divider == true ? 'border-top: 1px solid #ccc; margin-top:1rem;' : ''"
              />
            </template>
          </v-list>
        </v-menu>
      </v-btn>
      <div></div>
      <div></div>
    </v-container>

    <div v-if="isLoggedIn()" style="font-size: 0.9rem; width: 130px" class="d-none d-lg-block">
      <p>Hello,</p>
      <p>
        {{ userData.customerCode }}
        <v-tooltip activator="parent" location="left">{{ userData.email }}</v-tooltip>
      </p>
    </div>
    <v-menu v-if="isLoggedIn()">
      <template v-slot:activator="{ props }">
        <v-btn
          class="text-capitalize ml-3"
          size="comfortable"
          :icon="isAdmin ? 'mdi-shield-account' : 'mdi-account-circle'"
          v-bind="props"
        ></v-btn>
      </template>
      <v-list id="my-account" density="compact" nav class="text-center">
        <v-list-item title="My Account" @click="showMyAccount"></v-list-item>
        <v-list-item title="My Web Orders" @click="navigateTo('/myorders')" v-if="!isAdmin"></v-list-item>
        <v-list-item title="Statements" @click="navigateTo('/statements')" v-if="!isAdmin"></v-list-item>
        <v-list-item title="Credit Memo Status" @click="navigateTo('/creditMemos')" v-if="!isAdmin"></v-list-item>
        <v-list-item title="Open Order Status" @click="navigateTo('/openOrders')" v-if="!isAdmin"></v-list-item>
        <v-list-item title="Logout" @click="checkLogout"></v-list-item>
      </v-list>
    </v-menu>

    <v-btn v-if="isLoggedIn()" @click="openCart()" icon>
      <v-badge color="error" :content="cartStore.cartItemCount">
        <v-icon>mdi-cart</v-icon>
      </v-badge>
    </v-btn>
  </v-app-bar>

  <!-- For Mobile Drawer -->
  <v-navigation-drawer v-model="storeLeftNav.isRailOpen" app temporary class="d-lg-none">
    <v-list v-model:opened="open" density="compact" nav @click="storeLeftNav.isRailOpen = false">
      <template v-for="(n, i) in storeLeftNav.nav">
        <v-list-item
          v-if="!n.subItems"
          v-show="!n.groups || n.groups.includes(userData.userGroup)"
          :key="`${i}-a`"
          :to="n.to"
          link
          :href="n.url"
          :target="n.url ? '_blank' : ''"
          :rel="n.url ? 'noopener' : ''"
          :prepend-icon="n.icon"
          :title="n.label"
          @click="clearPage(n.to)"
        ></v-list-item>

        <v-list-group
          v-if="n.subItems"
          v-show="!n.groups || n.groups.includes(userData.userGroup)"
          :key="`${i}-b`"
          :value="i + '_' + n.label"
        >
          <template #activator="{ props }">
            <v-list-item
              v-show="!n.groups || n.groups.includes(userData.userGroup)"
              v-bind="props"
              :prepend-icon="n.icon"
              :title="n.label"
              @click="storeLeftNav.isRailOpen = true"
            ></v-list-item>
          </template>
          <template v-for="(s, y) in n.subItems">
            <v-list-item
              v-if="!s.subItems"
              v-show="!s.groups || s.groups.includes(userData.userGroup)"
              :key="`${y}-c`"
              :to="s.to"
              :active="isNavItemExactActive(s.to)"
              link
              :prepend-icon="s.icon"
              :title="s.label"
              @click="s.action != null ? handleClick(s.action) : clearPage(s.to)"
            >
              <template #append v-if="s.badge?.value && !!storeLeftNav.badgeValues[s.badge?.value]">
                <v-badge
                  :color="s.badge?.color || 'error'"
                  :content="storeLeftNav.badgeValues[s.badge?.value]"
                  inline
                ></v-badge>
              </template>
            </v-list-item>
            <v-list-group
              v-if="s.subItems"
              v-show="!s.groups || s.groups.includes(userData.userGroup)"
              :key="`${y}-d`"
              :value="y + '__' + s.label"
            >
              <template #activator="{ props }">
                <v-list-item
                  v-show="!s.groups || s.groups.includes(userData.userGroup)"
                  v-bind="props"
                  :prepend-icon="s.icon"
                  :title="s.label"
                ></v-list-item>
              </template>
              <template v-for="(t, z) in s.subItems">
                <v-list-item
                  v-if="!t.subItems"
                  v-show="!t.groups || t.groups.includes(userData.userGroup)"
                  :key="`${z}-e`"
                  :to="t.to"
                  :active="isNavItemExactActive(t.to)"
                  link
                  :prepend-icon="t.icon"
                  :title="t.label"
                  class="ml-4"
                  @click="clearPage(t.to)"
                ></v-list-item>
              </template>
            </v-list-group>
          </template>
        </v-list-group>
      </template>
    </v-list>
  </v-navigation-drawer>

  <v-snackbar
    v-model="systemBar.snackbar"
    v-if="systemBar.snackbarText != null"
    :timeout="systemBar.snackbarTimeout"
    elevation="24"
    location="center"
    vertical
  >
    {{ systemBar.snackbarText }}
    <template v-slot:actions>
      <v-btn color="pink" variant="text" @click="systemBar.snackbar = false"> Close </v-btn>
    </template>
  </v-snackbar>

  <v-dialog v-model="logoutDialog" width="auto">
    <v-card>
      <v-card-title class="text-center"> {{ userData.firstName }}, </v-card-title>
      <v-card-subtitle> </v-card-subtitle>
      <v-card-text> Are you sure you want to log out? </v-card-text>
      <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn variant="tonal" color="red" @click="dialog = false">Yes</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false">No</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions> -->

      <v-card-actions>
        <v-btn class="text-none mb-0" color="red-darken-3" size="large" variant="flat" block @click="logout">Yes</v-btn>
      </v-card-actions>
      <v-card-actions>
        <v-btn block class="text-none" color="grey-lighten-3" size="large" variant="flat" @click="logoutDialog = false"
          >No</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>

  <user-account-dialog ref="accountDialogRef"> </user-account-dialog>

  <confirm-dialog
    ref="confirmDialogRef"
    title="Logout"
    content="Are you sure you want to log out?"
    :hide-button="true"
    :use-yes-no="true"
    :show-cancel="false"
    :show-alert="true"
    @confirm:ok="logout"
  ></confirm-dialog>
</template>

<script setup>
// import, props, emits, use
useHead({
  titleTemplate: (titleChunk) => {
    return titleChunk ? `${titleChunk} - JOVANI` : 'JOVANI'
  },
  meta: [{ name: 'robots', content: 'noindex, nofollow' }]
})
import { useDisplay } from 'vuetify'
const { width, smAndDown: isMobile } = useDisplay()
const { isNavItemExactActive } = useNavItemExactActive()
const systemBar = useSystemBarStore()
const { userData, isLoggedIn, isAdmin } = useUserStore()
const { pageData } = usePageData()
const storeLeftNav = useLeftNavStore()
const cartStore = useCartStore()

// data
const logoutDialog = ref(false)
const accountDialogRef = shallowRef()
const confirmDialogRef = shallowRef()
const open = ref([])

onMounted(async () => {
  //console.log(`> Header - onMounted`)
  if (isLoggedIn()) cartStore.refreshCartItemCount()
})

// method
const logout = () => {
  logoutDialog.value = false
  navigateTo('/logout')
}
const openCart = () => {
  navigateTo('/cart')
}
const showMyAccount = () => {
  accountDialogRef.value.init()
}

const checkLogout = async () => {
  const result = await confirmDialogRef.value.confirm()
  if (result === 'yes') logout()
}

const clearPage = (toPath) => {
  pageData.page = 1

  if (toPath !== window.location.pathname) {
    pageData.itemsPerPage = 15
  }
}
const handleClick = (actionName) => {
  actions[actionName]?.()
}
const actions = {
  showMyAccount,
  logout: () => alert('Logging out...')
}
</script>

<style lang="scss" scoped>
#my-account {
  .v-list-item {
    min-height: 35px;
  }
}
</style>
